export var FLUTTER_SETTINGS = 'flutterSetting';
export var tabNames;
(function (tabNames) {
    tabNames["gameZone"] = "game_zone";
    tabNames["liveClass"] = "live_class";
    tabNames["liveClassEvent"] = "live_class_event";
    tabNames["curriculum"] = "curriculum";
    tabNames["home"] = "home";
    tabNames["classInvitesPopup"] = "class_invites_popup";
    tabNames["catexMigrationScreen"] = "catex_migration_screen";
    tabNames["printables"] = "printables";
})(tabNames || (tabNames = {}));
